import Vue from "vue"
import Router from "vue-router"
import queryString from "query-string"

import UserIndexPage from "./erp_src/view/user/ErpUserIndexPage.vue"

import DepartmentIndexPage from "./erp_src/view/department/DepartmentIndexPage.vue"
import DepartmentShowPage from "./erp_src/view/department/DepartmentShowPage.vue"
import DepartmentEditPage from "./erp_src/view/department/DepartmentEditPage.vue"
import DepartmentNewPage from "./erp_src/view/department/DepartmentNewPage.vue"
import DepartmentUserIndexPage from "./erp_src/view/department_user/DepartmentUserIndexPage.vue"

import AuthorityIndexPage from "./erp_src/view/authority/AuthorityIndexPage.vue"
import AuthorityNewPage from "./erp_src/view/authority/AuthorityNewPage.vue"
import AuthorityEditPage from "./erp_src/view/authority/AuthorityEditPage.vue"
import AuthorityUserIndexPage from "./erp_src/view/authority_user/AuthorityUserIndexPage.vue"

import FeatureIndexPage from "./erp_src/view/feature/FeatureIndexPage.vue"

import LedgerNewPage from "./erp_src/view/ledger/LedgerNewPage"
import LedgerShowPage from "./erp_src/view/ledger/LedgerShowPage"
import LedgerEditPage from "./erp_src/view/ledger/LedgerEditPage"
import LedgerIndexPage from "./erp_src/view/ledger/LedgerIndexPage"
import DailyReportTemplateIndexPage from "./erp_src/view/daily_report_template/DailyReportTemplateIndexPage.vue"
import DailyReportNewPage from "./erp_src/view/daily_report/DailyReportNewPage.vue"
import DailyReportEditPage from "./erp_src/view/daily_report/DailyReportEditPage.vue"
import DailyReportIndexPage from "./erp_src/view/daily_report/DailyReportIndexPage.vue"
import ExcelTemplateNewPage from "./erp_src/view/excel_templates/ExcelTemplateNewPage.vue"
import ExcelTemplateShowPage from "./erp_src/view/excel_templates/ExcelTemplateShowPage.vue"
import ExcelTemplateEditPage from "./erp_src/view/excel_templates/ExcelTemplateEditPage.vue"
import ExcelTemplateIndexPage from "./erp_src/view/excel_templates/ExcelTemplateIndexPage.vue"

import ErpTopPage from "../javascript/erp_src/view/erp/ErpTopPage.vue"
import ErpUserNewPage from "./erp_src/view/user/ErpUserNewPage.vue"
import ErpLoginPage from "./erp_src/view/user/ErpLoginPage.vue"
import PasswordResetPage from "./erp_src/view/user/PasswordResetPage.vue"
import PasswordResetNewPage from "./erp_src/view/user/PasswordResetNewPage.vue"
import PasswordEditPage from "./erp_src/view/user/PasswordEditPage.vue"
import ConfirmCompletePage from "./erp_src/view/user/ConfirmCompletePage.vue"
import AccountEditPage from "../javascript/erp_src/view/user/AccountEditPage.vue"
import ErpSettingPage from "../javascript/erp_src/view/erp/ErpSettingPage.vue"
import ErpUserIndexPage from "../javascript/erp_src/view/user/ErpUserIndexPage.vue"
import AuthorizedPersonUserEditPage from "../javascript/erp_src/view/user/AuthorizedPersonUserEditPage.vue"
import ErpUserEditPage from "../javascript/erp_src/view/user/ErpUserEditPage.vue"

import RequirementIndexPage from "./erp_src/view/requirement/RequirementIndexPage.vue"
import RequirementApprovalIndexPage from "./erp_src/view/requirement/RequirementApprovalIndexPage.vue"
import RequirementConfirmationIndexPage from "./erp_src/view/requirement/RequirementConfirmationIndexPage.vue"
import AnswerIndexPage from "./erp_src/view/answers/AnswerIndexPage.vue"
import AnswerNewPage from "./erp_src/view/answers/AnswerNewPage.vue"

import RequirementUserNewPage from "./erp_src/view/requirement_user/RequirementUserNewPage.vue"
import RequirementUserEditPage from "./erp_src/view/requirement_user/RequirementUserEditPage.vue"
import RequirementUserGanttChart from "./erp_src/view/requirement_user/RequirementUserGanttChart.vue"

import ProductIndexPage from "./erp_src/view/product/ProductIndexPage.vue"
import ProductNewPage from "./erp_src/view/product/ProductNewPage.vue"
import ProductShowPage from "./erp_src/view/product/ProductShowPage.vue"
import ProductEditPage from "./erp_src/view/product/ProductEditPage.vue"
import ProcessByClassificationGanttChartPage from "./erp_src/view/product/ProcessByClassificationGanttChartPage.vue"

import ComponentIndexPage from "./erp_src/view/component/ComponentIndexPage.vue"
import ComponentNewPage from "./erp_src/view/component/ComponentNewPage.vue"
import ComponentShowPage from "./erp_src/view/component/ComponentShowPage.vue"
import ComponentEditPage from "./erp_src/view/component/ComponentEditPage.vue"

import LogisticsIndexPage from "./erp_src/view/logistics/LogisticsIndexPage.vue"
import LogiQuoteIndexPage from "./erp_src/view/logi_quote/LogiQuoteIndexPage.vue"
import LogiQuoteNewPage from "./erp_src/view/logi_quote/LogiQuoteNewPage.vue"

import MessageIndexPage from "./erp_src/view/message/MessageIndexPage.vue"

import MatterIndexPage from "./erp_src/view/matter/MatterIndexPage.vue"
import MatterNewPage from "./erp_src/view/matter/MatterNewPage.vue"
import MatterShowPage from "./erp_src/view/matter/MatterShowPage.vue"
import MatterEditPage from "./erp_src/view/matter/MatterEditPage.vue"
import MatterFileIndexPage from "./erp_src/view/matter/MatterFileIndexPage.vue"
import ProductIndexByProcessPage from "./erp_src/view/product/ProductIndexByProcessPage.vue"
import MypageIndexPage from "./erp_src/view/mypage/MypageIndexPage.vue"
import CustomerCompanyIndexPage from "./erp_src/view/customer_company/CustomerCompanyIndexPage.vue"
import CustomerCompanyNewPage from "./erp_src/view/customer_company/CustomerCompanyNewPage.vue"
import CustomerCompanyEditPage from "./erp_src/view/customer_company/CustomerCompanyEditPage.vue"
import PrefixIndexPage from "./erp_src/view/product/PrefixIndexPage.vue"
import StockIndexPage from "./erp_src/view/stock/StockIndexPage.vue"
import LargeProcessIndexPage from "./erp_src/view/large_process/LargeProcessIndexPage.vue"
import LargeProcessTypeIndexPage from "./erp_src/view/large_process_type/LargeProcessTypeIndexPage.vue"

import OrderConfirmationIndexPage from "./erp_src/view/order_confirmation/OrderConfirmationIndexPage.vue"
import OrderConfirmationNewPage from "./erp_src/view/order_confirmation/OrderConfirmationNewPage.vue"
import OrderConfirmationShowPage from "./erp_src/view/order_confirmation/OrderConfirmationShowPage.vue"
import OrderConfirmationEditPage from "./erp_src/view/order_confirmation/OrderConfirmationEditPage.vue"
import TeamIndexPage from "./erp_src/view/teams/TeamsIndexPage.vue"

// インポートファイル挿入位置
import SampleShowPage from "./erp_src/view/sample/SampleShowPage.vue"
import SampleIndexPage from "./erp_src/view/sample/SampleIndexPage.vue"
import SampleNewPage from "./erp_src/view/sample/SampleNewPage.vue"
import SampleLoginPage from "./erp_src/view/sample/SampleLoginPage.vue"
import CreateMatter from "./erp_src/view/trial/CreateMatter.vue"
import CreateRequirement from "./erp_src/view/trial/CreateRequirement.vue"
import DrawingsIndexPage from "./erp_src/view/drawings/DrawingsIndexPage.vue"
import PrintedMatterIndexPage from "./erp_src/view/printed_matter/PrintedMatterIndexPage.vue"
import PrintedMatterShowPage from "./erp_src/view/printed_matter/PrintedMatterShowPage.vue"
import PrintedMatterRecordShowPage from "./erp_src/view/printed_matter_record/PrintedMatterRecordShowPage.vue"
import PrintedMatterRecordIndexPage from "./erp_src/view/printed_matter_record/PrintedMatterRecordIndexPage.vue"
import ComponentQuotesIndexPage from "./erp_src/view/component_quotes/ComponentQuotesIndexPage.vue"
import ComponentQuotesNewPage from "./erp_src/view/component_quotes/ComponentQuotesNewPage.vue"
import ManufactureOrderIndividualInfoIndexPage from "./erp_src/view/order_individual_info/ManufactureOrderIndividualInfoIndexPage.vue"
import ManufactureLargeProcessIndexPage from "./erp_src/view/large_process/ManufactureLargeProcessIndexPage.vue"
import ManufactureLargeProcessTypeIndexPage from "./erp_src/view/large_process_type/ManufactureLargeProcessTypeIndexPage.vue"
import AssignPermissionIndexPage from "./erp_src/view/assign_permission/AssignPermissionIndexPage.vue"
import RubberProcessIndexPage from "./erp_src/view/rubber_process/RubberProcessIndexPage.vue"
import RubberIndexPage from "./erp_src/view/rubber/RubberIndexPage.vue"
import OrderAllocationIndexPage from "./erp_src/view/order_allocation/OrderAllocationIndexPage.vue"
import OrderAllocationToTeamPage from "./erp_src/view/order_allocation/OrderAllocationToTeamPage.vue"
import OrderAllocationToTeamMemberPage from "./erp_src/view/order_allocation/OrderAllocationToTeamMemberPage.vue"

import OrderedProductPartsIndexPage from "./erp_src/view/ordered_product_parts/OrderedProductPartsIndexPage.vue"
import OrderDataIndexPage from "./erp_src/view/order_data/OrderDataIndexPage.vue"
import OrderDataNewPage from "./erp_src/view/order_data/OrderDataNewPage.vue"
import OrderDataEditPage from "./erp_src/view/order_data/OrderDataEditPage.vue"
import OrderComponentSearchPage from "./erp_src/view/order_data/OrderComponentSearchPage.vue"
import PurchaseOrderPage from "./erp_src/view/order_data/PurchaseOrderPage.vue"
import ComponentProcurementRequirementsIndexPage from "./erp_src/view/component_procurement_requirement/ComponentProcurementRequirementsIndexPage.vue"
import ComponentProcurementAnswersIndexPage from "./erp_src/view/component_procurement_requirement/ComponentProcurementAnswersIndexPage.vue"
import ComponentProcurementOrderPage from "./erp_src/view/component_procurement_requirement/ComponentProcurementOrderPage.vue"
import DeliveryOrderIndexPage from "./erp_src/view/delivery_order/DeliveryOrderIndexPage.vue"
import DeliveryOrderNewPage from "./erp_src/view/delivery_order/DeliveryOrderNewPage.vue"
import DeliveryOrderEditPage from "./erp_src/view/delivery_order/DeliveryOrderEditPage.vue"
import DeliveryOrderShowPage from "./erp_src/view/delivery_order/DeliveryOrderShowPage.vue"
import InventoryIndexPage from "./erp_src/view/inventory/InventoryIndexPage.vue"
import InventoryNewPage from "./erp_src/view/inventory/InventoryNewPage.vue"
import InventoryShowPage from "./erp_src/view/inventory/InventoryShowPage.vue"
import CostIndexPage from "./erp_src/view/cost/CostIndexPage.vue"
import StandardCostIndexPage from "./erp_src/view/cost/StandardCostIndexPage.vue"
import ManufactureOrderIndexPage from "./erp_src/view/manufacture_order/ManufactureOrderIndexPage.vue"
import UnissuedManufactureOrderIndexPage from "./erp_src/view/manufacture_order/UnissuedManufactureOrderIndexPage.vue"
import ProductionPlanningOrderIndividualInfoIndexPage from "./erp_src/view/order_individual_info/ProductionPlanningOrderIndividualInfoIndexPage.vue"
import ProductionPlanningAreaIndexPage from "./erp_src/view/order_individual_info/ProductionPlanningAreaIndexPage.vue"
import TeamOrderIndividualInfoIndexPage from "./erp_src/view/teams/TeamOrderIndividualInfoIndexPage.vue"
import ComponentShippingIndexPage from "./erp_src/view/component/ComponentShippingIndexPage.vue"
import RubberProcessTypeIndexPage from "./erp_src/view/rubber_process_type/RubberProcessTypeIndexPage.vue"
import RubberProcessTypRubberProcessIndexPage from "./erp_src/view/rubber_process_type/RubberProcessTypRubberProcessIndexPage.vue"
import ManufactureUserShowPage from "./erp_src/view/manufactures/ManufactureUserShowPage.vue"
import ManufactureOrderIndividualInfoShowPage from "./erp_src/view/manufactures/ManufactureOrderIndividualInfoShowPage.vue"
import RequiredTimeNewPage from "./erp_src/view/required_time/RequiredTimeNewPage.vue"
import CheckSheetShowPage from "./erp_src/view/check_sheet/CheckSheetShowPage.vue"
import RubberProcessUserShowPage from "./erp_src/view/rubber_process/RubberProcessUserShowPage.vue"
import RubberProcessShowPage from "./erp_src/view/rubber_process/RubberProcessShowPage.vue"
import CheckSheetIndexPage from "./erp_src/view/check_sheet/CheckSheetIndexPage.vue"
import CheckSheetNewPage from "./erp_src/view/check_sheet/CheckSheetNewPage.vue"
import CheckSheetEditPage from "./erp_src/view/check_sheet/CheckSheetEditPage.vue"
import CheckSheetTemplateIndexPage from "./erp_src/view/check_sheet_template/CheckSheetTemplateIndexPage.vue"
import CheckSheetTemplateShowPage from "./erp_src/view/check_sheet_template/CheckSheetTemplateShowPage.vue"
import CheckSheetTemplateNewPage from "./erp_src/view/check_sheet_template/CheckSheetTemplateNewPage.vue"
import CheckSheetTemplateEditPage from "./erp_src/view/check_sheet_template/CheckSheetTemplateEditPage.vue"
import AttachedFileTargetIndexPage from "./erp_src/view/attached_file/AttachedFileTargetIndexPage.vue"
import AttachedFileTargetShowPage from "./erp_src/view/attached_file/AttachedFileTargetShowPage.vue"
import QualityAssuranceAttachedFileIndexPage from "./erp_src/view/quality_assurance/QualityAssuranceAttachedFileIndexPage.vue"
import ProblemCaseIndexPage from "./erp_src/view/problem_case/ProblemCaseIndexPage.vue"
import ProblemCaseShowPage from "./erp_src/view/problem_case/ProblemCaseShowPage.vue"
import ProblemCaseNewPage from "./erp_src/view/problem_case/ProblemCaseNewPage.vue"
import ProblemCaseEditPage from "./erp_src/view/problem_case/ProblemCaseEditPage.vue"
import HoldingPointIndexPage from "./erp_src/view/holding_point/HoldingPointIndexPage.vue"
import PhotoOrderIndividualInfoIndexPage from "./erp_src/view/photo/PhotoOrderIndividualInfoIndexPage.vue"
import WitnessInspectionOrderIndividualInfoIndexPage from "./erp_src/view/witness_inspection/WitnessInspectionOrderIndividualInfoIndexPage.vue"
import FinalInspectionIndexPage from "./erp_src/view/final_inspection/FinalInspectionIndexPage.vue"
import InspectionReportOrderIndividualInfoIndexPage from "./erp_src/view/inspection_report/InspectionReportOrderIndividualInfoIndexPage.vue"
import InspectionReportOrderIndividualInfoShowPage from "./erp_src/view/inspection_report/InspectionReportOrderIndividualInfoShowPage.vue"
import NotifySalesIndexPage from "./erp_src/view/notify_sales/NotifySalesIndexPage.vue"
import BackupIndexPage from "./erp_src/view/backup/BackupIndexPage.vue"
import UnshippedOrderIndividualInfoIndexPage from "./erp_src/view/unshipped/UnshippedOrderIndividualInfoIndexPage.vue"
import ProductCategoryUserIndexPage from "./erp_src/view/product_category_user/ProductCategoryUserIndexPage.vue"
import QuotationIndexPage from "./erp_src/view/quotation/QuotationIndexPage.vue"
import QuotationShowPage from "./erp_src/view/quotation/QuotationShowPage.vue"
import QuotationNewPage from "./erp_src/view/quotation/QuotationNewPage.vue"
import QuotationEditPage from "./erp_src/view/quotation/QuotationEditPage.vue"
import SalesPendingIndexPage from "./erp_src/view/pending/SalesPendingIndexPage.vue"
import SalesMatterIndexPage from "./erp_src/view/sales/SalesMatterIndexPage.vue"
import SalesAlertIndexPage from "./erp_src/view/sales/SalesAlertIndexPage.vue"
import SalesOrderConfirmationNewPage from "./erp_src/view/sales/SalesOrderConfirmationNewPage.vue"
import SalesOrderConfirmationEditPage from "./erp_src/view/sales/SalesOrderConfirmationEditPage.vue"
import AreaOrderIndividualInfosIndexPage from "./erp_src/view/order_individual_info/AreaOrderIndividualInfosIndexPage.vue"
import OrderIndividualInfoStockIndexPage from "./erp_src/view/order_individual_info/OrderIndividualInfoStockIndexPage.vue"
import DesignCostIndexPage from "./erp_src/view/design_costs/DesignCostIndexPage.vue"
import ConstructionRequirementIndexPage from "./erp_src/view/construction/ConstructionRequirementIndexPage.vue"
import ConstructionCostIndexPage from "./erp_src/view/construction/ConstructionCostIndexPage.vue"
import ConstructionCostNewPage from "./erp_src/view/construction/ConstructionCostNewPage.vue"
import ConstructionCostShowPage from "./erp_src/view/construction/ConstructionCostShowPage.vue"
import ConstructionCostEditPage from "./erp_src/view/construction/ConstructionCostEditPage.vue"
import ConstructionIndexPage from "./erp_src/view/construction/ConstructionIndexPage.vue"
import PendingConstructionIndexPage from "./erp_src/view/construction/PendingConstructionIndexPage.vue"
import ConstructionProcessIndexPage from "./erp_src/view/construction/ConstructionProcessIndexPage.vue"
import ConstructionWorkerIndexPage from "./erp_src/view/construction/ConstructionWorkerIndexPage.vue"
import ConstructionConstructionWorkerIndexPage from "./erp_src/view/construction/ConstructionConstructionWorkerIndexPage.vue"
import ConstructionConstructionScheduleIndexPage from "./erp_src/view/construction/ConstructionConstructionScheduleIndexPage.vue"
import ConstructionConstructionScheduleReportPage from "./erp_src/view/construction/ConstructionConstructionScheduleReportPage.vue"
import ConstructionOutsourcingWorkerEditPage from "./erp_src/view/construction/ConstructionOutsourcingWorkerEditPage.vue"
import ConstructionOutsourcingWorkerShowPage from "./erp_src/view/construction/ConstructionOutsourcingWorkerShowPage.vue"
import ConstructionWorkerScheduleIndexPage from "./erp_src/view/construction/ConstructionWorkerScheduleIndexPage.vue"
import ConstructionCompletionCertificateShowPage from "./erp_src/view/construction/ConstructionCompletionCertificateShowPage.vue"
import ConstructionCompletionCertificateEditPage from "./erp_src/view/construction/ConstructionCompletionCertificateEditPage.vue"
import ConstructionStockIndexPage from "./erp_src/view/construction/ConstructionStockIndexPage.vue"
import ConstructionRubberIndexPage from "./erp_src/view/construction/ConstructionRubberIndexPage.vue"
import ConstructionInformationShowPage from "./erp_src/view/construction/ConstructionInformationShowPage.vue"
import ConstructionInformationPrintPage from "./erp_src/view/construction/ConstructionInformationPrintPage.vue"
import ConstructionPreparationEditPage from "./erp_src/view/construction/ConstructionPreparationEditPage.vue"
import ConstructionReportEditPage from "./erp_src/view/construction/ConstructionReportEditPage.vue"
import FeatureList from "./erp_src/view/FeatureList.vue"

Vue.use(Router)

export default new Router({
	mode: "history",
	parseQuery: (query) => {
		return queryString.parse(query, {
			arrayFormat: "bracket",
		})
	},
	stringifyQuery: (params) => {
		if (0 == Object.keys(params).length) {
			return ""
		} else {
			return (
				"?" +
				queryString.stringify(params, {
					arrayFormat: "bracket",
				})
			)
		}
	},
	routes: [
		{ path: "/erp", component: ErpTopPage, name: "erp_root" },
		{ path: "/erp/login", component: ErpLoginPage, name: "erp_login" },
		{ path: "/erp/users/passwords/reset", component: PasswordResetPage, name: "password_reset" },
		{
			path: "/erp/users/passwords/reset/new",
			component: PasswordResetNewPage,
			name: "password_reset_new",
		},
		{ path: "/erp/users/passwords/edit", component: PasswordEditPage, name: "password_edit" },
		{
			path: "/erp/users/confirm/complete",
			component: ConfirmCompletePage,
			name: "confirmation_complete_path",
		},
		{ path: "/erp/settings", component: ErpSettingPage, name: "erp_settings" },
		{ path: "/erp/account/edit", component: AccountEditPage, name: "account_edit" },
		{ path: "/erp/users/new", component: ErpUserNewPage, name: "erp_user_new" },
		{ path: "/erp/users", component: ErpUserIndexPage, name: "erp_users" },
		{ path: "/erp/users/:id/edit", component: ErpUserEditPage, name: "erp_users_edit" },
		{
			path: "/erp/users/:id/authorized_users/edit",
			component: AuthorizedPersonUserEditPage,
			name: "authorized_user_edit",
		},
		{ path: "/", component: UserIndexPage, name: "user_index" },

		{
			path: "/requirements",
			component: RequirementIndexPage,
			name: "requirement_index",
			props: true,
		},
		{ path: "/answers", component: AnswerIndexPage, name: "answer_index" },
		{ path: "/answers/new/:id", component: AnswerNewPage, name: "answer_new" },
		{ path: "/answers/edit/:id", component: AnswerNewPage, name: "answer_edit" },

		{ path: "/departments", component: DepartmentIndexPage, name: "department_index" },
		{ path: "/departments/new", component: DepartmentNewPage, name: "department_new" },
		{ path: "/departments/:id", component: DepartmentShowPage, name: "department_show" },
		{ path: "/departments/:id/edit", component: DepartmentEditPage, name: "department_edit" },
		{
			path: "/departments/:id/department_users",
			component: DepartmentUserIndexPage,
			name: "department_user_index",
		},
		{
			path: "/departments/:id/requirements/requirement_users/new",
			component: RequirementUserNewPage,
			name: "requirement_user_new",
		},
		{
			path: "/departments/:id/requirements/requirement_users/edit",
			component: RequirementUserEditPage,
			name: "requirement_user_edit",
		},
		{
			path: "/departments/:id/requirements/requirement_users_ganttchart",
			component: RequirementUserGanttChart,
			name: "requirement_users_ganttchart",
		},

		{ path: "/features", component: FeatureIndexPage, name: "feature_index" },

		{ path: "/authorities", component: AuthorityIndexPage, name: "authority_index" },
		{ path: "/authorities/new", component: AuthorityNewPage, name: "authority_new" },
		{ path: "/authorities/:id/edit", component: AuthorityEditPage, name: "authority_edit" },
		{
			path: "/authorities/:id/authority_users",
			component: AuthorityUserIndexPage,
			name: "authority_user_index",
		},

		{
			path: "/departments/:id/requirements/requirement_approval",
			component: RequirementApprovalIndexPage,
			name: "requirement_approval_index",
		},
		{
			path: "/departments/:id/requirements/requirement_confirmation",
			component: RequirementConfirmationIndexPage,
			name: "requirement_confirmation_index",
		},

		{ path: "/ledgers", component: LedgerIndexPage, name: "ledger_index" },
		{ path: "/ledgers/new", component: LedgerNewPage, name: "ledger_new" },
		{ path: "/ledgers/:id", component: LedgerShowPage, name: "ledger_show" },
		{ path: "/ledgers/:id/edit", component: LedgerEditPage, name: "ledger_edit" },
		{ path: "/excel_templates", component: ExcelTemplateIndexPage, name: "excel_template_index" },
		{ path: "/excel_templates/new", component: ExcelTemplateNewPage, name: "excel_template_new" },
		{ path: "/excel_templates/:id", component: ExcelTemplateShowPage, name: "excel_template_show" },
		{
			path: "/excel_templates/:id/edit",
			component: ExcelTemplateEditPage,
			name: "excel_template_edit",
		},

		{
			path: "/departments/:department_id/daily_report_templates",
			component: DailyReportTemplateIndexPage,
			name: "daily_report_template_index",
		},
		{
			path: "/templates/:template_id/daily_reports/new",
			component: DailyReportNewPage,
			name: "template_daily_report_new",
		},
		{
			path: "/daily_reports/new",
			component: DailyReportNewPage,
			name: "daily_report_new",
		},

		{
			path: "/templates/:template_id/daily_reports/:id/edit",
			component: DailyReportEditPage,
			name: "daily_report_edit",
		},
		{
			path: "/departments/:department_id/daily_reports",
			component: DailyReportIndexPage,
			name: "daily_report_index",
		},

		{ path: "/products", component: ProductIndexPage, name: "product_index" },
		{ path: "/products/new", component: ProductNewPage, name: "product_new" },
		{ path: "/products/:id", component: ProductShowPage, name: "product_show" },
		{ path: "/products/:id/edit", component: ProductEditPage, name: "product_edit" },
		{
			path: "/components/shippings",
			component: ComponentShippingIndexPage,
			name: "component_shipping_index",
		},
		{ path: "/components", component: ComponentIndexPage, name: "component_index" },
		{ path: "/components/new", component: ComponentNewPage, name: "component_new" },
		{ path: "/components/:id", component: ComponentShowPage, name: "component_show" },
		{ path: "/components/:id/edit", component: ComponentEditPage, name: "component_edit" },

		{ path: "/matters", component: MatterIndexPage, name: "matter_index" },
		{
			path: "/matters/order_confirmations",
			component: OrderConfirmationIndexPage,
			name: "order_confirmation_index",
		},
		{ path: "/matters/new", component: MatterNewPage, name: "matter_new" },
		{
			path: "/matters/:matter_id/order_confirmations/new",
			component: OrderConfirmationNewPage,
			name: "order_confirmation_new",
		},
		{ path: "/matters/:id", component: MatterShowPage, name: "matter_show" },
		{ path: "/matters/:id/edit", component: MatterEditPage, name: "matter_edit" },
		{ path: "/matters/:id/attached_files", component: MatterFileIndexPage, name: "attached_files" },
		{
			path: "/matters/:matter_id/order_confirmations/:id/edit",
			component: OrderConfirmationEditPage,
			name: "order_confirmation_edit",
		},
		{
			path: "/matters/:matter_id/order_confirmations/:id",
			component: OrderConfirmationShowPage,
			name: "order_confirmation_show",
		},
		{ path: "/messages", component: MessageIndexPage, name: "message_index" },
		{ path: "/users/:id/mypages", component: MypageIndexPage, name: "mypage_index" },
		{
			path: "/customer_companies",
			component: CustomerCompanyIndexPage,
			name: "customer_company_index",
		},
		{
			path: "/customer_companies/new",
			component: CustomerCompanyNewPage,
			name: "customer_company_new",
		},
		{
			path: "/customer_companies/:id/edit",
			component: CustomerCompanyEditPage,
			name: "customer_company_edit",
		},
		{
			path: "/logistics",
			component: LogisticsIndexPage,
			name: "logistics",
		},
		{
			path: "/logi_quotes",
			component: LogiQuoteIndexPage,
			name: "logi_quotes",
		},
		{
			path: "/logi_quotes/new",
			component: LogiQuoteNewPage,
			name: "logi_quotes_new",
		},
		{
			path: "/product_by_processes",
			component: ProductIndexByProcessPage,
			name: "product_by_process_index",
		},
		{
			path: "/trial/create_matter",
			component: CreateMatter,
			name: "trial_create_matter",
		},
		{
			path: "/trial/create_requirement",
			component: CreateRequirement,
			name: "trial_create_requirement",
		},
		{
			path: "/prefixes/:id/order_individual_infos",
			component: ProcessByClassificationGanttChartPage,
			name: "process_by_classification_ganttchart",
		},
		{
			path: "/large_process_types/:id/large_processes",
			component: LargeProcessIndexPage,
			name: "large_process_index",
		},
		{
			path: "/prefixes",
			component: PrefixIndexPage,
			name: "prefix_index",
		},
		{
			path: "/large_process_types",
			component: LargeProcessTypeIndexPage,
			name: "large_process_type_index",
		},
		{
			path: "/drawings",
			component: DrawingsIndexPage,
			name: "drawings",
		},
		{
			path: "/printed_matters",
			component: PrintedMatterIndexPage,
			name: "printed_matter_index",
		},
		{
			path: "/printed_matters/:id",
			component: PrintedMatterShowPage,
			name: "printed_matter_show",
		},
		{
			path: "/printed_matter_records/:id",
			component: PrintedMatterRecordShowPage,
			name: "printed_matter_record_show",
		},
		{
			path: "/printed_matters/:printed_matter_id/printed_matter_records",
			component: PrintedMatterRecordIndexPage,
			name: "printed_matter_record_index",
		},

		{
			path: "/stocks",
			component: StockIndexPage,
			name: "stocks",
		},
		{
			path: "/manufactures/order_individual_infos",
			component: ManufactureOrderIndividualInfoIndexPage,
			name: "manufacture_order_individual_info_index",
		},
		{
			path: "/manufactures/large_process_types/:id/large_processes",
			component: ManufactureLargeProcessIndexPage,
			name: "manufacture_large_process_index",
		},
		{
			path: "/manufactures/large_process_types/",
			component: ManufactureLargeProcessTypeIndexPage,
			name: "manufacture_large_process_type_index",
		},
		{
			path: "/assign_permission/:id",
			component: AssignPermissionIndexPage,
			name: "assign_permission",
		},
		{
			path: "/teams/order_individual_infos/",
			component: TeamOrderIndividualInfoIndexPage,
			name: "team_order_individual_info_index",
		},
		{
			path: "/teams/:id",
			component: TeamIndexPage,
			name: "team_index",
		},
		{
			path: "/rubber_processes",
			component: RubberProcessIndexPage,
			name: "rubber_process_index",
		},
		{
			path: "/rubbers",
			component: RubberIndexPage,
			name: "rubber_index",
		},
		{
			path: "/order_allocation",
			component: OrderAllocationIndexPage,
			name: "order_allocation",
		},
		{
			path: "/order_allocation/to_team",
			component: OrderAllocationToTeamPage,
			name: "order_allocation_to_team",
		},
		{
			path: "/order_allocation/to_team_member",
			component: OrderAllocationToTeamMemberPage,
			name: "order_allocation_to_team_member",
		},

		// ルートファイル挿入位置

		{ path: "/samples", component: SampleIndexPage, name: "sample_index" },
		{ path: "/samples/new", component: SampleNewPage, name: "sample_new" },
		{ path: "/samples/show", component: SampleShowPage, name: "sample_show" },
		{ path: "/samples/login", component: SampleLoginPage },
		{
			path: "/ordered_parts_list",
			component: OrderedProductPartsIndexPage,
			name: "ordered_parts_list",
		},
		{
			path: "/order_data",
			component: OrderDataIndexPage,
			name: "order_data",
		},
		{
			path: "/order_component_search",
			component: OrderComponentSearchPage,
			name: "order_component_search",
		},
		{
			path: "/order_data/:id/purchase_order",
			component: PurchaseOrderPage,
			name: "order_data_purchase_order",
		},

		{
			path: "/order_data/new",
			component: OrderDataNewPage,
			name: "order_data_new",
		},
		{
			path: "/order_data/:id/edit",
			component: OrderDataEditPage,
			name: "order_data_edit",
		},

		{
			path: "/component_quotes",
			component: ComponentQuotesIndexPage,
			name: "component_quotes_index",
		},

		{
			path: "/component_quotes/new",
			component: ComponentQuotesNewPage,
			name: "component_quotes_new",
		},
		{
			path: "/component_procurement_requirements",
			component: ComponentProcurementRequirementsIndexPage,
			name: "component_procurement_requirements_index",
		},
		{
			path: "/component_procurement_answers",
			component: ComponentProcurementAnswersIndexPage,
			name: "component_procurement_answers_index",
		},
		{
			path: "/component_procurement_requirement_order/:id",
			component: ComponentProcurementOrderPage,
			name: "component_procurement_requirement_order",
		},
		{
			path: "/delivery_orders/",
			component: DeliveryOrderIndexPage,
			name: "delivery_order_index",
		},
		{
			path: "/delivery_orders/new",
			component: DeliveryOrderNewPage,
			name: "delivery_order_new",
		},
		{
			path: "/delivery_orders/:id/edit",
			component: DeliveryOrderEditPage,
			name: "delivery_order_edit",
		},
		{
			path: "/delivery_orders/:id/order_sheets",
			component: DeliveryOrderShowPage,
			name: "delivery_order_show",
		},
		{
			path: "/inventories",
			component: InventoryIndexPage,
			name: "inventory_index",
		},
		{
			path: "/inventories/:id/new",
			component: InventoryNewPage,
			name: "inventory_new",
		},
		{
			path: "/inventories/:id",
			component: InventoryShowPage,
			name: "inventory_show",
		},
		{
			path: "/costs",
			component: CostIndexPage,
			name: "cost_index",
		},
		{
			path: "/standard_costs",
			component: StandardCostIndexPage,
			name: "standard_cost_index",
		},
		{
			path: "/manufacture_orders",
			component: ManufactureOrderIndexPage,
			name: "manufacture_order_index",
		},
		{
			path: "/manufacture_orders/unissued",
			component: UnissuedManufactureOrderIndexPage,
			name: "unissued_manufacture_order_index",
		},
		{
			path: "/production_plannings/:id/order_individual_infos",
			component: ProductionPlanningOrderIndividualInfoIndexPage,
			name: "production_planning_order_individual_info_index",
		},
		{
			path: "/production_plannings/:id/areas/",
			component: ProductionPlanningAreaIndexPage,
			name: "production_planning_area",
		},
		{
			path: "/rubber_process_types",
			component: RubberProcessTypeIndexPage,
			name: "rubber_process_type_index",
		},
		{
			path: "/rubber_process_types/:id/rubber_processes",
			component: RubberProcessTypRubberProcessIndexPage,
			name: "rubber_process_type_rubber_process_index",
		},
		{
			path: "/manufactures/users",
			component: ManufactureUserShowPage,
			name: "manufactures_user_show",
		},
		{
			path: "/manufactures/order_individual_infos/:id",
			component: ManufactureOrderIndividualInfoShowPage,
			name: "manufactures_order_individual_info_show",
		},
		{
			path: "/required_times/new",
			component: RequiredTimeNewPage,
			name: "required_time_new",
		},
		{
			path: "/check_sheets/:id/edit",
			component: CheckSheetEditPage,
			name: "check_sheet_edit",
		},
		{
			path: "/check_sheet_templates",
			component: CheckSheetTemplateIndexPage,
			name: "check_sheet_template_index",
		},
		{
			path: "/check_sheet_templates/new",
			component: CheckSheetTemplateNewPage,
			name: "check_sheet_template_new",
		},
		{
			path: "/check_sheet_templates/:id",
			component: CheckSheetTemplateShowPage,
			name: "check_sheet_template_show",
		},
		{
			path: "/check_sheet_templates/:id/edit",
			component: CheckSheetTemplateEditPage,
			name: "check_sheet_template_edit",
		},
		{
			path: "/problem_cases",
			component: ProblemCaseIndexPage,
			name: "problem_case_index",
		},
		{
			path: "/problem_cases/new",
			component: ProblemCaseNewPage,
			name: "problem_case_new",
		},
		{
			path: "/problem_cases/:id",
			component: ProblemCaseShowPage,
			name: "problem_case_show",
		},
		{
			path: "/problem_cases/:id/edit",
			component: ProblemCaseEditPage,
			name: "problem_case_edit",
		},
		{
			path: "/check_sheets/new",
			component: CheckSheetNewPage,
			name: "check_sheet_new",
		},
		{
			path: "/check_sheets/:id",
			component: CheckSheetShowPage,
			name: "check_sheet_show",
		},
		{
			path: "/check_sheets",
			component: CheckSheetIndexPage,
			name: "check_sheet_index",
		},
		{
			path: "/holding_points",
			component: HoldingPointIndexPage,
			name: "holding_point_index",
		},
		{
			path: "/rubber_processes/users",
			component: RubberProcessUserShowPage,
			name: "rubber_process_user_show",
		},
		{
			path: "/rubber_processes/:id",
			component: RubberProcessShowPage,
			name: "rubber_process_show",
		},
		{
			path: "/photos/order_individual_infos",
			component: PhotoOrderIndividualInfoIndexPage,
			name: "photo_order_individual_info_index",
		},
		{
			path: "/witness_inspections/order_individual_infos",
			component: WitnessInspectionOrderIndividualInfoIndexPage,
			name: "witness_inspection_order_individual_info_index",
		},
		{
			path: "/final_inspections",
			component: FinalInspectionIndexPage,
			name: "final_inspection_index",
		},
		{
			path: "/notify_sales",
			component: NotifySalesIndexPage,
			name: "notify_sales_index",
		},
		{
			path: "/inspection_reports/order_individual_infos",
			component: InspectionReportOrderIndividualInfoIndexPage,
			name: "inspection_report_index",
		},
		{
			path: "/inspection_reports/order_individual_infos/:id",
			component: InspectionReportOrderIndividualInfoShowPage,
			name: "inspection_report_show",
		},
		{
			path: "/backups",
			component: BackupIndexPage,
			name: "backup_index",
		},
		{
			path: "/unshipped_order_individual_infos",
			component: UnshippedOrderIndividualInfoIndexPage,
			name: "unshipped_order_individual_info_index",
		},
		{
			path: "/quality_assurances/product_category_users",
			component: ProductCategoryUserIndexPage,
			name: "quality_assurance_product_category_user_index",
		},
		{
			path: "/quotations",
			component: QuotationIndexPage,
			name: "quotation_index",
		},
		{
			path: "/quotations/new",
			component: QuotationNewPage,
			name: "quotation_new",
		},
		{
			path: "/quotations/:id",
			component: QuotationShowPage,
			name: "quotation_show",
		},
		{
			path: "/quotations/:id/edit",
			component: QuotationEditPage,
			name: "quotation_edit",
		},
		{
			path: "/quality_assurances/attached_files",
			component: QualityAssuranceAttachedFileIndexPage,
			name: "quality_assurance_attached_file_index",
		},
		{
			path: "/attached_files/targets",
			component: AttachedFileTargetIndexPage,
			name: "attached_file_index",
		},
		{
			path: "/attached_files/:type_id/:id",
			component: AttachedFileTargetShowPage,
			name: "attached_file_show",
		},
		{
			path: "/sales/pendings",
			component: SalesPendingIndexPage,
			name: "sales_pending_index",
		},
		{
			path: "/sales/matters",
			component: SalesMatterIndexPage,
			name: "sales_matter_index",
		},
		{
			path: "/sales/matters/:id/order_confirmations/new",
			component: SalesOrderConfirmationNewPage,
			name: "sales_order_confirmation_new",
		},
		{
			path: "/sales/order_confirmations/:id/edit",
			component: SalesOrderConfirmationEditPage,
			name: "sales_order_confirmation_edit",
		},
		{
			path: "/sales/alerts",
			component: SalesAlertIndexPage,
			name: "sales_alert_index",
		},
		{
			path: "/areas/order_individual_infos",
			component: AreaOrderIndividualInfosIndexPage,
			name: "area_order_individual_info_index",
		},
		{
			path: "/order_individual_infos/stocks",
			component: OrderIndividualInfoStockIndexPage,
			name: "order_individual_info_stock_index",
		},
		{
			path: "/design_costs",
			component: DesignCostIndexPage,
			name: "design_costs_index",
		},
		{
			path: "/constructions/requirements",
			component: ConstructionRequirementIndexPage,
			name: "construction_requirement_index",
		},
		{
			path: "/constructions/costs",
			component: ConstructionCostIndexPage,
			name: "construction_cost_index",
		},
		{
			path: "/constructions/requirements/:id/costs/new",
			component: ConstructionCostNewPage,
			name: "construction_cost_new",
		},
		{
			path: "/constructions/costs/:id",
			component: ConstructionCostShowPage,
			name: "construction_cost_show",
		},
		{
			path: "/constructions/costs/:id/edit",
			component: ConstructionCostEditPage,
			name: "construction_cost_edit",
		},
		{
			path: "/constructions",
			component: ConstructionIndexPage,
			name: "construction_index",
		},
		{
			path: "/constructions/pendings",
			component: PendingConstructionIndexPage,
			name: "construction_pending_index",
		},
		{
			path: "/constructions/constructions/:id/construction_processes",
			component: ConstructionProcessIndexPage,
			name: "construction_process_index",
		},
		{
			path: "/constructions/workers",
			component: ConstructionWorkerIndexPage,
			name: "construction_worker_index",
		},
		{
			path: "/constructions/constructions/:id/workers",
			component: ConstructionConstructionWorkerIndexPage,
			name: "construction_construction_worker_index",
		},
		{
			path: "/constructions/constructions/:id/schedules",
			component: ConstructionConstructionScheduleIndexPage,
			name: "construction_construction_schedule_index",
		},
		{
			path: "/constructions/schedules/:id/report",
			component: ConstructionConstructionScheduleReportPage,
			name: "construction_construction_schedule_report",
		},
		{
			path: "/constructions/outsourcing_worker_arrangements/:id/edit",
			component: ConstructionOutsourcingWorkerEditPage,
			name: "construction_outsourcing_worker_edit",
		},
		{
			path: "/constructions/outsourcing_worker_arrangements/:id",
			component: ConstructionOutsourcingWorkerShowPage,
			name: "construction_outsourcing_worker_show",
		},
		{
			path: "/constructions/workers/schedules",
			component: ConstructionWorkerScheduleIndexPage,
			name: "constructions_worker_schedule_index",
		},
		{
			path: "/constructions/completion_certificates/:id",
			component: ConstructionCompletionCertificateShowPage,
			name: "constructions_completion_certificate_show",
		},
		{
			path: "/constructions/completion_certificates/:id/edit",
			component: ConstructionCompletionCertificateEditPage,
			name: "constructions_completion_certificate_edit",
		},
		{
			path: "/constructions/stocks",
			component: ConstructionStockIndexPage,
			name: "constructions_stock_index",
		},
		{
			path: "/constructions/:id/rubbers",
			component: ConstructionRubberIndexPage,
			name: "constructions_rubber_index",
		},
		{
			path: "/constructions/construction_informations/:id",
			component: ConstructionInformationShowPage,
			name: "constructions_information_show",
		},
		{
			path: "/constructions/construction_informations/:id/print",
			component: ConstructionInformationPrintPage,
			name: "constructions_information_print",
		},
		{
			path: "/constructions/preparations/:id/edit",
			component: ConstructionPreparationEditPage,
			name: "constructions_preparation_edit",
		},
		{
			path: "/constructions/reports/:id/edit",
			component: ConstructionReportEditPage,
			name: "constructions_report_edit",
		},
		{
			path: "/feature_list",
			component: FeatureList,
			name: "feature_list",
		},
	],
})
